import { TestContext } from 'yup'

import {
  OPTIONAL_RECORDING_NUMBER_SPECIES,
  PLACE_TYPE_MATERNITY_HOME,
} from './fieldsOptions'

import translation from 'i18next'

export const _validateRecordingNumber = (
  value: string | undefined,
  context: TestContext,
  specieField = 'specie'
) => {
  const specie = context.parent[specieField]
  const placeType = context.parent.place_type

  if (placeType === PLACE_TYPE_MATERNITY_HOME && value === undefined) {
    return context.createError({
      message: translation.t('errors:validation.requiredRecordingForMaternity'),
    })
  }

  if (
    specie &&
    !OPTIONAL_RECORDING_NUMBER_SPECIES.includes(specie) &&
    value === undefined
  ) {
    return context.createError({
      message: translation.t('errors:validation.requiredRecordingForSpecie', {
        specie,
      }),
    })
  }

  return true
}

export const validateRecordingNumber = (
  value: string | undefined,
  context: TestContext
) => _validateRecordingNumber(value, context)

export const validateRecordingNumberForSpecie2 = (
  value: string | undefined,
  context: TestContext
) => _validateRecordingNumber(value, context, 'specie2')

export const validateRecordingNumberForSpecie3 = (
  value: string | undefined,
  context: TestContext
) => _validateRecordingNumber(value, context, 'specie3')

export const validateRecordingNumberForSpecie4 = (
  value: string | undefined,
  context: TestContext
) => _validateRecordingNumber(value, context, 'specie4')
